<template>
  <div class="modal fade" :class="{open: image}" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="headerId">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" :id="headerId">Delete Image</h4>
        </div>
        <div v-if="image" class="modal-body">
          <div class="mb-3">Do you really want to delete this image?</div>
          <img :src="image.url" :alt="image.file_name" class="img-responsive img-rounded mx-auto" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click="onDeleteClick">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'delete-image-modal',
  props: {
    image: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      headerId: 'delete-image-modal-header',
      modalId: 'delete-image-modal',
    };
  },
  watch: {
    image(image) {
      $(`#${this.modalId}`).modal(image ? 'show' : 'hide');
    },
  },
  methods: {
    onDeleteClick() {
      this.$emit('delete');
    },
  },
  mounted() {
    $(`#${this.modalId}`).on('hidden.bs.modal', () => this.$emit('hide'));
  },
};
</script>

<style lang="scss" scoped>
button.close:hover {
  background-color: unset;
}
</style>
